import useSWR from 'swr';
import { useAuthStore } from './useAuth';

interface DockDetails {
    dock: {
        id: string;
        dockNumber: string;
        status: string;
        type: string;
    };
    appointment: {
        id: string;
        carrierName: string;
        carrierMcNumber: string;
        driverName?: string;
        status: string;
        checkInTime: string;
        type: string;
    } | null;
    pos: {
        poNumber: string;
        customerPoNumber: string;
        totalSkids: number;
        totalWeight: number;
    }[];
}

const fetcher = async (url: string, token: string) => {
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Failed to fetch details');
    return res.json();
};

export function useDockDetails(dockId: string | null) {
    const { token } = useAuthStore();

    const { data, error, isLoading, mutate } = useSWR<DockDetails>(
        dockId && token ? [`/api/docks/${dockId}/details`, token] : null,
        ([url, token]) => fetcher(url, token as string),
        { refreshInterval: 10000 } // Poll every 10s for live updates
    );

    return {
        details: data,
        isLoading,
        isError: error,
        mutate
    };
}
